const STEP_DAYS = { daily: 1, weekly: 7, biweekly: 14 };
const STEP_MONTHS = { monthly: 1, semiannual: 6, yearly: 12 };

// Month steps clamp to the target month's length: Jan 31 + 1 month is Feb 28,
// not the Mar 3 that setMonth overflows to. That is what iOS's Calendar does,
// and the two clients have to agree — a skipped cycle is stored under its
// expected date, so a bill on the 31st was otherwise skipped on one client and
// still owed on the other. Time of day is kept.
function addMonthsClamped(date, n) {
  const d = new Date(date);
  const day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + n);
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, lastDay));
  return d;
}

export function nextOccurrence(lastDate, recurrenceType) {
  const d = new Date(lastDate);
  if (STEP_MONTHS[recurrenceType]) return addMonthsClamped(d, STEP_MONTHS[recurrenceType]);
  const days = STEP_DAYS[recurrenceType];
  if (!days) return d;
  d.setDate(d.getDate() + days);
  return d;
}

export function expandRecurring(template, fromDate, toDate) {
  const { lastDate, recurrenceType, endDate } = template;
  if (!recurrenceType) return [];
  const from = new Date(fromDate);
  const to = new Date(toDate);
  const cap = endDate ? new Date(endDate) : null;

  const out = [];
  let cursor = nextOccurrence(lastDate, recurrenceType);
  let safety = 0;
  while (cursor <= to && safety < 10000) {
    if (cap && cursor > cap) break;
    if (cursor >= from) out.push(new Date(cursor));
    cursor = nextOccurrence(cursor, recurrenceType);
    safety++;
  }
  return out;
}
